import React, { useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Button,
} from '@chakra-ui/react';

const SupplierModals = ({
  isCreateModalOpen,
  isEditModalOpen,
  onCloseCreate,
  onCloseEdit,
  onSubmitCreate,
  onSubmitEdit,
  formData,
  setFormData,
}) => {
  useEffect(() => {
    if (isCreateModalOpen) {
      // Clear form data when opening "Create New Supplier" modal
      setFormData({
        name: '',
        email: '',
        phone_number: '',
        edrpou_code: '',
        address: '',
        bank_name: '',
        bank_number: '',
      });
    }
  }, [isCreateModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      {/* Create Modal */}
      <Modal isOpen={isCreateModalOpen} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Додати постачальника</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb="4">
              <FormLabel>Назва</FormLabel>
              <Input name="name" value={formData.name} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Email</FormLabel>
              <Input name="email" value={formData.email} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Номер телефону</FormLabel>
              <Input
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>ЄДРПОУ</FormLabel>
              <Input name="edrpou_code" value={formData.edrpou_code} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Адреса</FormLabel>
              <Input name="address" value={formData.address} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Назва банку</FormLabel>
              <Input name="bank_name" value={formData.bank_name} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Номер рахунку</FormLabel>
              <Input name="bank_number" value={formData.bank_number} onChange={handleChange} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onSubmitCreate}>
              Зберегти
            </Button>
            <Button variant="ghost" onClick={onCloseCreate}>
              Скасувати
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Edit Modal */}
      <Modal isOpen={isEditModalOpen} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Редагувати постачальника</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb="4">
              <FormLabel>Назва</FormLabel>
              <Input name="name" value={formData.name} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Email</FormLabel>
              <Input name="email" value={formData.email} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Номер телефону</FormLabel>
              <Input
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>ЄДРПОУ</FormLabel>
              <Input name="edrpou_code" value={formData.edrpou_code} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Адреса</FormLabel>
              <Input name="address" value={formData.address} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Назва банку</FormLabel>
              <Input name="bank_name" value={formData.bank_name} onChange={handleChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Номер рахунку</FormLabel>
              <Input name="bank_number" value={formData.bank_number} onChange={handleChange} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onSubmitEdit}>
              Оновити
            </Button>
            <Button variant="ghost" onClick={onCloseEdit}>
              Скасувати
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SupplierModals;
